import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = ["title"]

import { PropType, computed } from 'vue'
import FileUploadState from '@inriver/types/src/enums/FileUploadState'

import FileUploadOngoingIcon from './icons/FileUploadOngoingIcon.vue'
import FileUploadSuccessIcon from './icons/FileUploadSuccessIcon.vue'
import FileUploadErrorIcon from './icons/FileUploadErrorIcon.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  label: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    default: '',
  },
  state: {
    type: String as PropType<FileUploadState>,
    required: true,
  },
},
  emits: ['cancel', 'navigate', 'remove'],
  setup(__props) {

const props = __props





const isClickable = computed(() => props.state === FileUploadState.SUCCESS)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", {
    class: _normalizeClass(["file-upload-accordion-item flex items-center whitespace-nowrap px-5 py-5 space-x-5", _unref(isClickable) && 'cursor-pointer hover:bg-grey-lighter']),
    onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(isClickable) && _ctx.$emit('navigate')))
  }, [
    _createElementVNode("span", {
      class: "file-upload-accordion-item__name flex-1 truncate",
      title: __props.label
    }, _toDisplayString(__props.label), 9, _hoisted_1),
    (__props.description)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: "file-upload-accordion-item__description flex-1 text-grey-dark text-right truncate",
          title: __props.description
        }, _toDisplayString(__props.description), 9, _hoisted_2))
      : _createCommentVNode("", true),
    (__props.state === _unref(FileUploadState).PROCESSING || __props.state === _unref(FileUploadState).UPLOADING)
      ? (_openBlock(), _createBlock(FileUploadOngoingIcon, {
          key: 1,
          "onClick:cancel": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('cancel')))
        }))
      : (__props.state === _unref(FileUploadState).SUCCESS)
        ? (_openBlock(), _createBlock(FileUploadSuccessIcon, {
            key: 2,
            "onClick:navigate": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('navigate')))
          }))
        : (_openBlock(), _createBlock(FileUploadErrorIcon, {
            key: 3,
            "onClick:remove": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('remove')))
          }))
  ], 2))
}
}

})